var codeblocks = function codeblocks(tree, options) {
  options = options || {};
  var lang = options.lang || 'all';
  var name = options.name || 'codeblocks';
  var formatter = options.formatter || function (v) {
    return v;
  };
  var children = tree.children;
  var data = {};
  var i = -1;
  var child;
  if (lang === 'all') {
    data[name] = {};
  } else {
    data[name] = [];
  }
  while (++i < children.length) {
    child = children[i];
    if (child.type === 'code' && child.value) {
      if (lang === 'all') {
        child.lang = child.lang || '_';
        data[name][child.lang] = data[name][child.lang] || [];
        data[name][child.lang].push(formatter(child.value));
      } else {
        if (child.lang === lang) {
          data[name].push(formatter(child.value));
        }
      }
    }
  }
  return data;
};
module.exports = function (options) {
  return function (tree, file) {
    var data = codeblocks(tree, options);
    file.data = Object.assign({}, file.data, data);
  };
};
module.exports.codeblocks = function (tree, options) {
  return codeblocks(tree, options);
};